export const GRID_DAYS_MAX_RECURRING = 365

export const clampStudyDay = day => (day != null && typeof day === 'number' && day < 1 ? 1 : day)
